import {Box, Flex, FormLabel, Text} from '@chakra-ui/react';
import React from 'react';
import {get} from '../../service/ApiService';
import {Department} from '../../service/Urls';
import {Controller} from 'react-hook-form';
import Select from 'react-select';
import {useQuery} from 'react-query';

export const DepartmentSelect = props => {
  const {data, isLoading} = useQuery(['department', 'dropdown'], () => new Promise(res => setTimeout(() => res(get(Department.DROPDOWN)), 3000)));

  const departments =
    data?.data?.map(dept => ({
      value: dept?.dpCode,
      label: `${dept?.dpCode ?? ''} | ${dept?.dpDesc ?? ''}`,
    })) ?? [];

  return (
    <>
      <Controller
        name={props.name}
        control={props.control}
        rules={{required: props.required}}
        render={({field: {value, onChange, ...rest}, fieldState: {error}}) => {
          return (
            <Flex mx={1}>
              <Box w="100%">
                <FormLabel fontSize="sm" mb="-0.5" ml="1">
                  Select Department
                </FormLabel>
                <Select
                  {...rest}
                  value={departments?.find(dept => dept.value === value) ?? null}
                  onChange={(newValue, actionMeta) => {
                    if (props.setDeptCode) {
                      props.setDeptCode(newValue?.label?.split(' ')[0]);
                    }
                    onChange(newValue?.value, actionMeta);
                  }}
                  options={departments}
                  isDisabled={props.isReadOnly}
                  isLoading={isLoading}
                  isClearable
                />

                {error && (
                  <Text color="red.400" fontSize="sm">
                    * Department is required
                  </Text>
                )}
              </Box>
            </Flex>
          );
        }}
      />
    </>
  );
};
